
import React from 'react'
import ReactDOM from 'react-dom'
import AppWithAuth from './AppWithAuth'
import { AuthProvider } from 'react-oidc-context'
import { getConfig } from './config/appConfig'
import * as serviceWorker from './serviceWorker'

const initializeApp = async () => {
  try {
    const appConfig = await getConfig()

    const oidcConfig = {
      authority: appConfig.issuer,
      client_id: appConfig.clientId,
      redirect_uri: window.location.origin,
      post_logout_redirect_uri: window.location.origin,
    }

    ReactDOM.render(
      <AuthProvider {...oidcConfig}>
        <AppWithAuth />
      </AuthProvider>,
      document.getElementById('root')
    )
  } catch (error) {
    console.error('Failed to initialize app:', error)
    // Render error state or fallback
    ReactDOM.render(
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>Configuration Error</h1>
        <p>Failed to load application configuration. Please try refreshing the page.</p>
      </div>,
      document.getElementById('root')
    )
  }
}

// Initialize the app
initializeApp()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
